import React from 'react';
import DocumentsTab from '../components/dashboard/DocumentsTab';

export default function DocumentsPage() {
  return (
    <div className="px-4 sm:px-6 py-6 max-w-4xl mx-auto animate-fade-in">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-slate-800">Documents</h1>
        <p className="text-sm text-slate-500 mt-0.5">Upload and manage your application documents</p>
      </div>
      <DocumentsTab />
    </div>
  );
}
